// TODO: Remove following variables from global scope
// TODO: Raise errors if elements can't be queried
const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
if (mobileMenuToggle === null) { throw new Error('mobile-menu-toggle element is null'); }
const mobileDropdown = document.getElementById('mobile-dropdown');
if (mobileDropdown === null) { throw new Error('mobile-dropdown element is null'); }
const header = document.querySelector('.header');
if (header === null) { throw new Error('.header element is null'); }

const SCROLL_THRESHOLD = 5;
const MAX_HEADER_SHOW_HEIGHT = 80;
let lastScrollTop = 0;

// TODO: Convert `closeDropdown` to traditional function
const closeDropdown = () => {
    mobileMenuToggle.classList.remove('header__dropdown-icon--active');
    mobileDropdown.classList.remove('header__dropdown-menu--active');
    header.classList.remove('header--expanded');
};

// TODO: Replace click handler with a named function
mobileMenuToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    const isActive = mobileMenuToggle.classList.toggle('header__dropdown-icon--active');
    mobileDropdown.classList.toggle('header__dropdown-menu--active');
    if (isActive) {
        header.classList.add('header--expanded');
    } else {
        header.classList.remove('header--expanded');
    }
});

// TODO: Replace click handler with a named function
document.addEventListener('click', () => {
    if (mobileDropdown.classList.contains('header__dropdown-menu--active')) {
        closeDropdown();
    }
});

window.addEventListener('resize', closeDropdown);

// TODO: Create initialization function

// Show header when mouse near top of screen
document.addEventListener('mousemove', function(e) {
    if (e.clientY < MAX_HEADER_SHOW_HEIGHT) {
        header.classList.remove('header--hidden');
    }
});

// Hide/show header based on scroll direction
window.addEventListener('scroll', function() {
    const currentScroll = window.scrollY;
    
    // Ignore small scroll movements
    if (Math.abs(currentScroll - lastScrollTop) < SCROLL_THRESHOLD) {
        return;
    }
    
    // Close dropdown on scroll
    if (mobileDropdown.classList.contains('header__dropdown-menu--active')) {
        closeDropdown();
    }
    
    // Hide header when scrolling down, show when scrolling up
    if (currentScroll > lastScrollTop && currentScroll > MAX_HEADER_SHOW_HEIGHT) {
        header.classList.add('header--hidden');
    } else {
        header.classList.remove('header--hidden');
    }
    
    lastScrollTop = currentScroll;
});
